var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CSwitch',{attrs:{"isChecked":_vm.value,"isDisabled":_vm.disabled},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }